export const perPageCount = 10;
export const errorTitle = "Oh Snap!";
